module.exports = __webpack_public_path__ + "img/user.d8d009fa.png";